import React from 'react';
import supportStyles from './styles/support.scss';
import logo from '../../assets/images/rtspro-logo-blue.svg';
import { Button } from 'shamrock-clover-ui';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { RootState } from 'bootstrap';

const Support = (props) => {
  const { t } = useTranslation();
  const EMAIL = 'support@rtspro.com ';
  const MAILTO = 'mailto:support@rtspro.com?subject=RTS Pro Support';
  const CALL = `${t('or call')} (888) 874 - 7053.`;

  return (
    <React.Fragment>
      <div className={supportStyles.container}>
        <div className={supportStyles.rtsProLogo}>
          <img src={logo} alt="rtspro_blue_logo" />
        </div>
        <div className={supportStyles.subtitle}>
          <p>{t('contact_us_header')}</p>
        </div>
        <div className={supportStyles.content}>
          <p>{t('contact_us_desc_1')}</p>
        </div>
        <div className={supportStyles.content}>
          <p>
            {t('email_us')}
            <a className={supportStyles.email} href={MAILTO} data-testid="contact-us-email-link">
              {EMAIL}
            </a>
            {CALL}
          </p>
        </div>
        <div className={supportStyles.button}>
          <Button width={'124px'} onClick={props.handleShowAsSupportPage} data-testid="contact-us-back-button">
            <span className={supportStyles.buttonText}>{t('go_back')}</span>
          </Button>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Support;
